import React, { FC } from 'react';
import {
  IReportBuilderFormik,
  TCurrentFilterType,
  TGroupingItem,
} from 'domains/ReportBuilder/types';
import { FormikProps } from 'formik';
import Checkbox from 'components/UI/Checkbox/checkbox';
import { checkedLocalization } from 'utils/checkedLocalization';

interface IRenderNoProps {
  formik: FormikProps<IReportBuilderFormik>;
  item: TGroupingItem;
  currentValue: TCurrentFilterType | null;
  formikKey: keyof IReportBuilderFormik['reportFilters'];
  currentKey: string;
}

export const RenderNo: FC<IRenderNoProps> = ({
  formik,
  item,
  currentValue,
  formikKey,
  currentKey,
}) => {
  const { data, label } = item;
  const checkboxData = data as TCurrentFilterType;
  const isSingleCheckbox = typeof checkboxData === 'boolean';
  const checkboxKeys = isSingleCheckbox
    ? [currentKey]
    : Object.keys(checkboxData as unknown as Record<string, boolean>);

  const currentCheckboxValue =
    typeof currentValue === 'boolean'
      ? currentValue
      : (currentValue as unknown as Record<string, boolean>);

  const labelWithTranslate = checkedLocalization(`reportbuilder.groupings.${label}`,label, false)

  return (
    <>
      {checkboxKeys.map((checkboxKey) => {
        const checked = isSingleCheckbox
          ? Boolean(currentCheckboxValue)
          : Boolean(
              (currentCheckboxValue as Record<string, boolean>)[checkboxKey],
            );

        return (
          <Checkbox
            key={`${currentKey}-${checkboxKey}`}
            label={labelWithTranslate}
            inputAttributes={{
              type: 'checkbox',
              checked,
              onChange: (e) => {
                const value = e.target.checked;
                if (isSingleCheckbox) {
                  formik.setFieldValue(
                    `reportFilters.${formikKey}.${currentKey}`,
                    value,
                  );
                  return;
                }

                const currentValueObject =
                  typeof currentCheckboxValue === 'object' &&
                  currentCheckboxValue !== null
                    ? (currentCheckboxValue as Record<string, boolean>)
                    : {};

                formik.setFieldValue(
                  `reportFilters.${formikKey}.${currentKey}`,
                  {
                    ...currentValueObject,
                    [checkboxKey]: value,
                  },
                );
              },
            }}
          />
        );
      })}
    </>
  );
};
